// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__Gcci0","value":"styles_value__so5Ue","skeleton-animation":"styles_skeleton-animation__RQcPX"};